import { Component, OnInit, Input } from '@angular/core';
import { BookResult } from 'src/app/models/api_models/book';

@Component({
  selector: 'app-book-edit-block',
  templateUrl: './book-edit-block.component.html',
  styleUrls: ['./book-edit-block.component.scss']
})
export class BookEditBlockComponent implements OnInit {

  private _start : Date = null;
  get start() : Date {return this._start;}
  set start(start : Date) {this._start = start;}
  


  private _hour: string = null;
  get hour() : string { return this._hour;}
  set hour(hour : string) {this._hour = hour;}

  private _min: string = null;
  get min() : string {return this._min;}
  set min(min : string) {this._min = min;}

  private _book : BookResult = null;
  get book() : BookResult {
    return this._book;
  }
  @Input()
  set book(book : BookResult) {
    this._book = book;
    if (this._book !== null) {
      this._start = new Date(this._book.startdate);
      this._start.setTime(this._start.getTime() - (1000 * 60 * 60 *2));
      this._hour = this._start.getHours().toString();
      this._min = this._start.getMinutes().toString();
    }
  }

  constructor() { }

  ngOnInit() {
  }

}
